import Image from 'next/image';
import Link from 'next/link';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
import React, { useEffect, useRef, useState } from 'react';

export default function imagefourbox(props) {
  /**
   *  
   * 1."text_color":"b",   의 의미 ??  타입 대신 쓰임
   * 2. 링크주소 정리 
   * 3. talk 서비스 주소 정의
   * 
   */
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a,b,c,d,e) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '큐레이션 모듈', //모듈 아이디 없으면
        moduleTitle: e, //모듈 제목 (Require)
        moduleSubTitle: '연속이미지형(4개)',
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: c, //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle:'', //프로그램의 아이디 (추가)
        contentId:  b.link_url,//식별자
        contentTitle: b.title, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: 'LK', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };

  return (

    <>
      {/* <!-- 연속성이미지타이틀 -->*/}
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
          </div>
          <div className={"listModule_w_imgSeries imgSeriess" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  props.data.contents.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_imgSeries">
                          <Link href={item.link_url} >
                            <a   onClick={(e) => handleClick(e, item,index,'인기', props.data.list_title)} target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <img src={item.img_url} className="mb_image" alt={item.img_attr} />
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}